<mat-form-field class="is-comfortably-readable">
    @if (autoPopulated()) {
        <mat-icon
            class="auto-populate-icon"
            [matTooltip]="'research.auto.populate.tooltip' | customTranslate"
            matPrefix
            svgIcon="auto-populate"
        ></mat-icon>
    }
    <mat-label>{{ policyFieldLabel() }}</mat-label>
    <mat-select [formControl]="policyFieldControl()">
        <mat-option [value]="null">--{{ 'research.settings.research.none' | customTranslate }}--</mat-option>
        @for (option of policyFieldOptions(); track option) {
            @if (option.code !== otbAccessPolicyType.Local || localPolicyEnabled()) {
                <mat-option [value]="option?.code"
                    >{{
                        option.code
                            | defaultTranslate
                                : {
                                      default: option.description,
                                  }
                    }}
                </mat-option>
            }
        }
    </mat-select>
    @if (policyFieldHint()) {
        <mat-hint>{{ policyFieldHint() }}</mat-hint>
    }

    @if (policyFieldControl()?.invalid) {
        <mat-error [innerHTML]="policyFieldControl().errors | errorTranslate"></mat-error>
    }
</mat-form-field>
@if (isEmbargo()) {
    <mat-form-field class="is-comfortably-readable">
        <mat-label>{{ embargoDateLabel() }}</mat-label>
        <input matInput [matDatepicker]="picker" [formControl]="embargoDateControl()" />
        @if (embargoDateHint()) {
            <mat-hint>{{ embargoDateHint() }}</mat-hint>
        }
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if (embargoDateControl()?.invalid) {
            <mat-error [innerHTML]="embargoDateControl().errors | errorTranslate"></mat-error>
        }
    </mat-form-field>
    @if (embargoPeriodEnabled()) {
        <mat-form-field class="is-comfortably-readable">
            <mat-label>{{ embargoPeriodLabel() }}</mat-label>
            <mat-select [formControl]="embargoPeriodControl()">
                @for (option of embargoPeriodOptions(); track option) {
                    <mat-option [value]="option?.code"
                        >{{
                            option.code
                                | defaultTranslate
                                    : {
                                          default: option.description,
                                      }
                        }}
                    </mat-option>
                }
            </mat-select>
            @if (embargoPeriodHint()) {
                <mat-hint>{{ embargoPeriodHint() }}</mat-hint>
            }

            @if (embargoPeriodControl()?.invalid) {
                <mat-error [innerHTML]="embargoPeriodControl().errors | errorTranslate"></mat-error>
            }
        </mat-form-field>
    }
}

@if (isLocalPolicy()) {
    <mat-form-field class="is-comfortably-readable">
        <mat-label>{{ localPolicyLabel() }}</mat-label>
        <mat-select [formControl]="localPolicyControl()">
            @for (option of localPolicyOptions(); track option) {
                <mat-option [value]="option?.code"
                    >{{
                        option.code
                            | defaultTranslate
                                : {
                                      default: option.name,
                                  }
                    }}
                </mat-option>
            }
        </mat-select>
        @if (localPolicyHint()) {
            <mat-hint>{{ localPolicyHint() }}</mat-hint>
        }

        @if (localPolicyControl()?.invalid) {
            <mat-error [innerHTML]="localPolicyControl().errors | errorTranslate"></mat-error>
        }
    </mat-form-field>
}

@if (allowsNote()) {
    <mat-form-field class="is-comfortably-readable">
        <mat-label>{{ noteFieldLabel() }}</mat-label>
        <input matInput [formControl]="noteFieldControl()" />
        @if (noteFieldHint()) {
            <mat-hint>{{ noteFieldHint() }}</mat-hint>
        }
        @if (noteFieldControl()?.invalid) {
            <mat-error [innerHTML]="noteFieldControl().errors | errorTranslate"></mat-error>
        }
    </mat-form-field>
}
